export enum PrinterTypeEnum {
  Fiscal = 0,
  Thermal
}
